import { Workspace } from '../../../interfaces/workspaces'

class WorkspacesAction {

  static REQUEST_WORKSPACES = 'REQUEST_WORKSPACES'
  static RECEIVE_WORKSPACES = 'RECEIVE_WORKSPACES'
  static RECEIVE_WORKSPACESNOCOUNTS = 'RECEIVE_WORKSPACES_NO_COUNTS'
  static RECEIVE_REMAININGWORKSPACES = 'RECIEVE_REMAINING_WORKSPACES'
  static REQUEST_ALLWORKSPACES = 'REQUEST_ALL_WORKSPACES'

  static requestWorkspaces = () => ({
    type: WorkspacesAction.REQUEST_WORKSPACES
  })
  
  static requestAllWorkspaces = () => ({
    type: WorkspacesAction.REQUEST_ALLWORKSPACES
  })

  static receiveWorkspaces = (workspaces: Workspace[]) => ({
    type: WorkspacesAction.RECEIVE_WORKSPACES,
    payload: {
      workspaces: workspaces
    }
  })

  static receiveWorkspacesNoCounts = (workspaces: Workspace[]) => ({
    type: WorkspacesAction.RECEIVE_WORKSPACESNOCOUNTS,
    payload: {
      workspaces: workspaces
    }
  })

  static recieveTotalWorkspaces = (remainingWorkspaces: number, totalWorkspaces: number) => ({
    type: WorkspacesAction.RECEIVE_REMAININGWORKSPACES,
    payload: {
      remainingWorkspaces: remainingWorkspaces,
      totalWorkspaces: totalWorkspaces
    }
  })

}

export default WorkspacesAction